module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-inner-800.6f90459e.svg";